export class UploadCancelledError extends Error {
  constructor() {
    super('Upload cancelled')
    this.name = 'UploadCancelledError'
  }
}

export const isUploadCancelledError = (error) =>
  error?.name === 'UploadCancelledError' ||
  error?.code === 'ERR_CANCELED' ||
  error?.name === 'CanceledError'

export const createUploadCancellation = () => {
  let aborted = false
  const abortControllers = []

  return {
    getSignal: () => {
      const controller = new AbortController()
      abortControllers.push(controller)
      return controller.signal
    },
    cancel: () => {
      if (aborted) return
      aborted = true
      abortControllers.forEach((controller) => controller.abort())
    },
    isCancelled: () => aborted,
  }
}
